<section>
  <div class="wrapper">
    <article class="mrt-75" style="overflow: auto !important;min-height: calc(100vh - 117px);">
      <!-- <div style="margin-bottom: 20px;">
        <a routerLink="/cp/archive-dashboard" class="headerLink" style="font-weight:600; color:#294058;" *ngIf="isAdminUser">Archive Dashboard</a>
      </div> -->
      <!-- <h4>Pro-View Users Activity Metrics</h4> -->
      <mat-tab-group #tabGroup [selectedIndex]="selectedTab" (selectedTabChange)="onTabChange($event)"  *ngIf="showCPLogs">
        <div class="tab-header">
          <mat-tab label="Dashboard">
            <div class="tab-content">
              <div class="graph-container">
                <app-session-graph [selectedTab]="selectedTab"></app-session-graph>
                <app-session-bar-graph [selectedTab]="selectedTab"></app-session-bar-graph>
              </div>
              <app-session-summary [selectedTab]="selectedTab" (tabSwitch)="switchTab($event)"></app-session-summary>
              <app-page-summary [selectedTab]="selectedTab"></app-page-summary>
            </div>
          </mat-tab>
          <mat-tab label="User Session Details">
            <div class="tab-content">
              <app-session-table [selectedTab]="selectedTab"></app-session-table>
            </div>
          </mat-tab>
          <mat-tab label="Page Activity">
            <div class="tab-content">
              <app-page-activity-table [selectedTab]="selectedTab"></app-page-activity-table>
            </div>
          </mat-tab>
          <!-- <button mat-icon-button color="primary" (click)="refreshData()" class="refresh-button">
            <mat-icon>refresh</mat-icon>
          </button> -->
        </div>
      </mat-tab-group>
      <div *ngIf="!showCPLogs" class="center-content">
        <mat-card class="card-one">
          <mat-card-content class="card-content">
            You don't have permissions to view this dashboard, please contact administrator.
          </mat-card-content>
        </mat-card>
      </div>
    </article>
  </div>
</section>
